import { TimePicker as AntTimePicker, TimePickerProps as AntTimePickerProps } from 'antd';
import { Dayjs } from 'dayjs';
import styles from './time-picker.module.scss';
import { MobileTimePicker } from './mobile-time-picker';
import { useScreenSize } from '@/hooks/use-screen-size/use-screen-size';

type TimePickerProps = AntTimePickerProps;

export function TimePicker({
  className,
  value,
  onChange,
  disabled,
  status,
  ...props
}: TimePickerProps) {
  const screenSize = useScreenSize();

  const isMobile = screenSize.width < 1024;

  if (isMobile) {
    return (
      <MobileTimePicker
        value={value as Dayjs | null}
        onChange={(newValue) => onChange?.(newValue, newValue.format('HH:mm'))}
        disabled={disabled}
        status={status === 'error' || status === 'warning' ? status : undefined}
        className={className}
      />
    );
  }

  return (
    <AntTimePicker
      format="HH:mm"
      showNow={false}
      value={value}
      onChange={onChange}
      disabled={disabled}
      status={status}
      className={`${styles.timePicker} ${className || ''}`}
      classNames={{
        popup: {
          root: styles.timePickerDropdown,
        },
      }}
      getPopupContainer={(trigger) => trigger.parentElement || document.body}
      {...props}
    />
  );
}
